(ns frontend.view.system-settings.view
  (:require
   [common.localization :as loc]
   [frontend.state.current-session :as session]
   [re-frame.core :as rf]
   [frontend.page-components.default-page-layout :as default-page-layout]
   [frontend.view.system-settings.event :as event]
   [frontend.view.system-settings.sub :as sub]
   [frontend.routing :as routing]))

(defn insider-groups
  []
  [:<>
   [:h4
    {:class "pt-4 font-bold"
     :on-click (fn [_]
                 (routing/set-view! [:settings/insider-groups]))}
    (loc/tr :insider-groups-title)]])

(defn surveys
  []
  [:<>
   [:h2
    {:class "pb-4 font-bold"
     :on-click (fn [_]
                 (routing/set-view! [:settings/surveys]))}
    (loc/tr :survey-configurations)]])

(defn team-and-security
  []
  [:div
   {:class "p-4 flex flex-col border border-solid border-base-light-border-paler rounded divide-y divide-solid divide-base-light-border-paler"}
   [:div
    {:class "pb-4 font-bold"}
    (loc/tr :teams-and-security)]
   [:div
    {:class ""}
    (when (session/insider-group-admin?)
      [insider-groups])
    (when (session/surveys-admin?)
      [surveys])]])

(defn view
  []
  [:div
   
   {:class "p-4 flex flex-col gap-4 container mx-auto"}
   [:h1
    {:class "flex items-center gap-4 py-3 text-xl"}
    [:i.fas.fa-cog]
    (loc/tr :system-settings-and-preferences)]

   [team-and-security]])

(defmethod routing/render-view :system-settings
  [_]
  [default-page-layout/view
   {:class-name "zap-page personal-profile"}
   [view]])
